import {
  colorTextStatusSuccess,
  colorTextStatusWarning,
  colorTextStatusError,
} from '@cloudscape-design/design-tokens'

/**
 * Returns the appropriate Cloudscape design token color for a latency value.
 * - < 100ms → success (green)
 * - 100–300ms → warning (yellow/orange)
 * - > 300ms → error (red)
 */
export function getLatencyColor(ms: number): string {
  if (ms < 100) return colorTextStatusSuccess
  if (ms <= 300) return colorTextStatusWarning
  return colorTextStatusError
}
